export const getGroupCalls= (userData)=>{

return (
    [
        {value:"@STOCK",label:'All Stocks'},
        {value: `@felix${userData}`, label: 'My Watchlist'},
        {value:"@ETF",label:"All ETFs"},
        {value:"@SP500",label:"S&P 500"},
        {value:"@TOP500",label:"Top 500"},
        {value:"@LARGECAP",label:"Large Cap"},
        {value:"@MIDCAP",label:"Mid Cap"},
        {value:"@SMALLCAP",label:"Small Cap"},
        {value:"@EARNINGS10",label:"Earnings < 10 Days"},
        {value: '@CONST1', label: 'Food & Beverage'},
         {value: '@CONST2', label: 'Food & Drug Retailing'},
         {value: '@CONST3', label: 'Personal & Household Products & Services'},
         {value: '@CYC1', label: 'Automobiles & Auto Parts'},
         {value: '@CYC2', label: 'Cyclical Consumer Products'},
         {value: '@CYC3', label: 'Cyclical Consumer Services'},
         {value: '@CYC4', label: 'Retailers'},
         {value: '@ENER1', label: 'Energy - Fossil Fuels'},
         {value: '@ENER2', label: 'Renewable Energy'},
         {value: '@ENER3', label: 'Uranium'},
         {value: '@FIN1', label: 'Banking & Investment Services'},
         {value: '@FIN2', label: 'Collective Investments'},
         {value: '@FIN3', label: 'Holding Companies'},
         {value: '@FIN4', label: 'Insurance'},
         {value: '@FIN5', label: 'Real Estate'},
         {value: '@HLTH1', label: 'Health Care Services'},
         {value: '@HLTH2', label: 'Pharmaceuticals & Medical Research'},
         {value: '@IND1', label: 'Industrial & Commercial Services'},
         {value: '@IND2', label: 'Industrial Conglomerates'},
         {value: '@IND3', label: 'Industrial Goods'},
         {value: '@IND4', label: 'Transportation'},
         {value: '@IT1', label: 'Software & IT Services'},
         {value: '@IT2', label: 'Technology Equipment'},
         {value: '@MAT1', label: 'Applied Resources'},
         {value: '@MAT2', label: 'Chemicals'},
         {value: '@MAT3', label: 'Mineral Resources'},  
    ]
);




}


export const GroupCalls = [
{value:"@STOCK",label:'All Stocks'},
{value: '@9232', label: 'My Watchlist'},
{value:"@ETF",label:"All ETFs"},
{value:"@SP500",label:"S&P 500"},
{value:"@TOP500",label:"Top 500"},
{value:"@LARGECAP",label:"Large Cap"},
{value:"@MIDCAP",label:"Mid Cap"},
{value:"@SMALLCAP",label:"Small Cap"},
{value:"@EARNINGS10",label:"Earnings < 10 Days"},
{value: '@CONST1', label: 'Food & Beverage'},
 {value: '@CONST2', label: 'Food & Drug Retailing'},
 {value: '@CONST3', label: 'Personal & Household Products & Services'},
 {value: '@CYC1', label: 'Automobiles & Auto Parts'},
 {value: '@CYC2', label: 'Cyclical Consumer Products'},
 {value: '@CYC3', label: 'Cyclical Consumer Services'},
 {value: '@CYC4', label: 'Retailers'},
 {value: '@ENER1', label: 'Energy - Fossil Fuels'},
 {value: '@ENER2', label: 'Renewable Energy'},
 {value: '@ENER3', label: 'Uranium'},
 {value: '@FIN1', label: 'Banking & Investment Services'},
 {value: '@FIN2', label: 'Collective Investments'},
 {value: '@FIN3', label: 'Holding Companies'},
 {value: '@FIN4', label: 'Insurance'},
 {value: '@FIN5', label: 'Real Estate'},
 {value: '@HLTH1', label: 'Health Care Services'},
 {value: '@HLTH2', label: 'Pharmaceuticals & Medical Research'},
 {value: '@IND1', label: 'Industrial & Commercial Services'},
 {value: '@IND2', label: 'Industrial Conglomerates'},
 {value: '@IND3', label: 'Industrial Goods'},
 {value: '@IND4', label: 'Transportation'},
 {value: '@IT1', label: 'Software & IT Services'},
 {value: '@IT2', label: 'Technology Equipment'},
 {value: '@MAT1', label: 'Applied Resources'},
 {value: '@MAT2', label: 'Chemicals'},
 {value: '@MAT3', label: 'Mineral Resources'},
]

export const TwoWeekText = " > 2 weeks"

export const ResultCalls = [
    {value:20,label:20},
    {value:50,label:50},
    {value:100,label:100}
]




// WEBPACK FOOTER //
// ./src/Pages/HomePage/constants.js